import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Eye, EyeOff, LogIn } from 'lucide-react';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      toast.success(`Welcome back, ${user.username}!`);
      navigate(user.role === 'admin' ? '/admin' : '/');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 pt-16 bg-grid">
      <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse at 50% 30%, rgba(255,107,0,0.1) 0%, transparent 60%)' }} />
      <div className="w-full max-w-sm relative z-10">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-2xl mx-auto mb-4 flex items-center justify-center" style={{ background: 'linear-gradient(135deg,#FF6B00,#F5A623)' }}>
            <span className="text-white font-bold text-xl" style={{ fontFamily: 'Sora' }}>CM</span>
          </div>
          <h1 className="text-2xl font-bold" style={{ fontFamily: 'Sora' }}>Welcome back</h1>
          <p className="text-brand-muted text-sm mt-1">Sign in to your CryptoMart account</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 glass rounded-2xl p-6">
          <div>
            <label className="block text-sm font-medium text-brand-muted mb-1.5">Email</label>
            <input type="email" className="input-dark" placeholder="you@email.com" required
              value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <label className="block text-sm font-medium text-brand-muted mb-1.5">Password</label>
            <div className="relative">
              <input type={show ? 'text' : 'password'} className="input-dark pr-10" placeholder="••••••••" required
                value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
              <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-brand-muted">
                {show ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full flex items-center justify-center gap-2">
            {loading ? <div className="spinner" /> : <><LogIn size={16} /> Sign In</>}
          </button>
        </form>

        <p className="text-center text-sm text-brand-muted mt-4">
          Don't have an account?{' '}
          <Link to="/register" className="text-brand-orange font-semibold hover:underline">Create one free</Link>
        </p>
      </div>
    </div>
  );
}
